import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { CheckPasswordInterfaceState } from '../../store/state/check-password.state';
import {
  UpdateCheckPasswordVisibility,
  UpdateCheckPasswordVisibilitySuccess
} from '../../store/actions/check-password.actions';
import { CheckPasswordInterface } from '../../models/check-password.interface';
import { CustomerService } from '../../../account/services/customer.service';
import { TogglePasswordService } from '../../../authentication/services/toggle-password.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-check-password',
  templateUrl: './check-password.component.html',
  styleUrls: ['./check-password.component.css'],
  standalone: false
})
export class CheckPasswordComponent implements OnInit {

  result: CheckPasswordInterface = null;
  password: string;
  environment = environment;

  constructor(
      private store: Store<any>,
      private customerService: CustomerService,
      public togglePasswordService: TogglePasswordService
  ) {}

  ngOnInit() {
    this.password = null;
    if (this.result != null) {
      this.result.visibility = null;
      this.result.isValid = null;
    }
    this.store.pipe(select(ConstsHelper.REDUCER_CHECK_PASSWORD)).subscribe((response: CheckPasswordInterfaceState) => {
      if (response.result != null) {
        this.result = response.result;
      }
    });
  }

  close() {
    this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: false, isValid: null, password: null, page: null}));
  }

  submit() {
    this.customerService.checkPassword(this.password).subscribe(
        response => {
          this.result.visibility = false;
          this.result.isValid = true;
          this.result.password = this.password;
          this.store.dispatch(new UpdateCheckPasswordVisibilitySuccess(this.result));
          this.store.dispatch(new UpdateCheckPasswordVisibility(this.result));
        }, error => {
          this.result.visibility = true;
          this.result.isValid = false;
          this.result.password = null;
          this.store.dispatch(new UpdateCheckPasswordVisibility(this.result));
        }
    );
  }
}
